import React from 'react';

interface ModalOpenButtonProps {
  className?: string;
  ariaLabel: string;
  handleOpen: () => void;
}

function ModalOpenButton({ className, handleOpen, ariaLabel }: ModalOpenButtonProps): React.ReactElement {
  return (
    <button
      aria-label={ariaLabel}
      type="button"
      className={`${className || ''} absolute-top-left`}
      onClick={handleOpen}
    >
      &nbsp;
    </button>
  );
}

export default ModalOpenButton;
